      <section> 
        <!--<div class="demo-icon-xs">        
          <a routerLink='/home/home'>    
          <img src="assets/images/icons/arrow_blue-left.svg" alt=""></a>
          </div> -->                   
          <!--<a (click)="Volver()">Volver</a>-->
              <h1>Preguntas frecuentes</h1>             
              <section class="scyr-faqs">
                <div class="buscador-faqs">
                  <div class="input-field buscador-faqs__input-buscar">
                    <input class="quicksearch" id="buscar" type="search" placeholder="Buscar">
                    <span class="icon-ng ico-search">
                      <img src="assets/images/icons/search.svg" alt="">
                    </span>
                  </div>
                </div>
                <ul class="contenedor-faqs" id="exampleAccordion">
                  <li class="contenedor-faqs__item-sizer"></li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion1" aria-expanded="true" aria-controls="Accordion1">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion1" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur,
                        nunc lorem consequat ligula, vel sodales libero ipsum sit amet augue. Vestibulum rhoncus volutpat
                        tincidunt. Aenean feugiat, lectus et ullamcorper suscipit, mi enim cursus urna, non finibus quam
                        nisi vel dolor. </p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion2" aria-expanded="true" aria-controls="Accordion2">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion2" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur,
                        nunc lorem consequat ligula, vel sodales libero ipsum sit amet augue. </p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion3" aria-expanded="true" aria-controls="Accordion3">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion3" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur.</p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion4" aria-expanded="true" aria-controls="Accordion4">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion4" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur,
                        nunc lorem consequat ligula, vel sodales libero ipsum sit amet augue.
                      </p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion5" aria-expanded="true" aria-controls="Accordion5">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion5" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur,
                        nunc lorem consequat ligula, vel sodales libero ipsum sit amet augue. Vestibulum rhoncus volutpat
                        tincidunt. Aenean feugiat, lectus et ullamcorper suscipit, mi enim cursus urna, non finibus quam
                        nisi vel dolor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos
                        himenaeos. Phasellus eget congue tellus, ac convallis dolor. </p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item">
                    <div class="collapsible-header">
                      <a data-toggle="collapse" href="#Accordion6" aria-expanded="true" aria-controls="Accordion6">
                        <h2>Vestibulum rhoncus volutpat tincidunt.</h2>
                      </a>
                    </div>
                    <div class="collapsible-body collapse" id="Accordion6" role="tabpanel">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin suscipit, neque auctor placerat consectetur,
                        nunc lorem consequat ligula, vel sodales libero ipsum sit amet augue. Vestibulum rhoncus volutpat
                        tincidunt. Aenean feugiat, lectus et ullamcorper suscipit, mi enim cursus urna, non finibus quam
                        nisi vel dolor. </p>
                    </div>
                  </li>
                  <li class="contenedor-faqs__item no-resultados">
                    <div class="collapsible-header">
                      <h2>
                        <strong>No hemos encontrado resultados para "
                          <span></span>"</strong>
                      </h2>
                    </div>
                  </li>
                </ul>
              </section>
            </section>
